/* eslint-disable no-console */
import { Injectable } from '@angular/core';
import { LocalStorage } from './storage/local';
import { CimaUrl } from 'core/services/cima/url';
import { CimaToken } from 'core/services/cima/token';

@Injectable({
    providedIn: 'root'
})
export class UserIdleService {
    public val: string;
    public MINUTES_UNTIL_AUTO_LOGOUT: number = 15;
    public CHECK_INTERVAL: number = 5000;
    public IDLE_KEY: string =  'lastAction';

    private cimaUrl: CimaUrl;
    private cimaToken: CimaToken;
    private localStorage: LocalStorage;
    
    constructor(localStorage: LocalStorage, cimaUrl: CimaUrl, cimaToken: CimaToken) {
        Object.assign(this, { localStorage, cimaUrl, cimaToken });
        localStorage.set(this.IDLE_KEY, Date.now().toString());
        this.idleCheck();
        this.eventListener();
        this.initInterval();
    }

    public eventListener(): void {
        document.body.addEventListener('click', () => this.reset());
        document.body.addEventListener('mouseover', ()=> this.reset());
        document.body.addEventListener('mouseout', () => this.reset());
        document.body.addEventListener('keydown', () => this.reset());
        document.body.addEventListener('keyup', () => this.reset());
        document.body.addEventListener('keypress', () => this.reset());
        window.addEventListener('storage', () => this.storageEvent());
    }

    public reset(): void {
        this.setLastAction(Date.now());
    }

    public initInterval(): void {
        setInterval(() => {
            this.idleCheck();
        }, this.CHECK_INTERVAL);
    }

    public idleCheck(): void {
        const now: number = Date.now();
        const timeleft: number = this.getLastAction() + this.MINUTES_UNTIL_AUTO_LOGOUT * 60 * 1000;
        const diff: number = timeleft - now;
        const isTimeout: boolean = diff < 0 || isNaN(diff);
    
        if (isTimeout && this.cimaToken.isLoggedIn)  {
            window.localStorage.clear();
            this.cimaUrl.redirectToLogout();
        }
    }

    public storageEvent(): void {
        this.val = this.localStorage.get(this.IDLE_KEY);
    }

    public getLastAction(): number {
        return parseInt(this.localStorage.get(this.IDLE_KEY));
    }

    public setLastAction(lastAction: number): void {
        this.localStorage.set(this.IDLE_KEY, lastAction.toString());
    }
}
